import { render } from "./HeroiconsSolidPhoneMissedCall.vue?vue&type=template&id=6b904d2b"
const script = {}

import exportComponent from "/home/nginx/domains/panel.vip-mod.net/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPhoneMissedCall.vue"]])

export default __exports__